export default "__VITE_PUBLIC_ASSET__7038ea3f__"